import { render, staticRenderFns } from "./prdEmptyState.vue?vue&type=template&id=552c5d76&scoped=true&"
import script from "./prdEmptyState.vue?vue&type=script&lang=js&"
export * from "./prdEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./prdEmptyState.vue?vue&type=style&index=0&id=552c5d76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c5d76",
  null
  
)

export default component.exports